import React, { useEffect } from 'react';
import { WrappedComponentProps, useIntl } from 'react-intl';
import { formatColorStr } from '../../../hooks/color-hooks';
import {
    ICustomColor,
    IOrderDetails,
    IProductDetail,
    IProductHoverImage,
    StateResult,
} from '../../../models/product-detail';
import { CartItemTypes, MIRACLEEAR } from '../../common/constants';
import ColorSelector from './color-selector';
import { debug } from 'console';
interface IColorSection {
    productDetailState: IProductDetail;
    productHoverImage: IProductHoverImage | undefined;
    orderState: IOrderDetails;
    faceplates: ICustomColor[];
    shells: ICustomColor[];
    onChange: (stateResult: StateResult) => void;
    onHover: (productImage?: IProductHoverImage) => void;
}
export const ColorSection = ({
    productDetailState,
    productHoverImage,
    orderState,
    faceplates,
    shells,
    onChange,
    onHover,
}: IColorSection) => {
    const intl = useIntl();

    const translateColor = (format: boolean, type: string) => {
        let str = '';
        switch (type) {
            case 'Case':
                if (productHoverImage && productHoverImage.color) {
                    str = productHoverImage.color;
                } else if (
                    productDetailState.isCustom &&
                    productDetailState.faceplateColor
                ) {
                    str = productDetailState.faceplateColor;
                } else {
                    str = productDetailState.color;
                }
                break;
            case 'Shell':
                if (productHoverImage && productHoverImage.shellColor) {
                    str = productHoverImage.shellColor;
                } else {
                    if (productDetailState.shellColor) {
                        str = productDetailState.shellColor;
                    }
                }

            default:
                break;
        }
        if (format) {
            return formatColorStr(str);
        }
        return str;
    };

    return (
        <>
            {![
                CartItemTypes.ApReceiver,
                CartItemTypes.Earmold,
                CartItemTypes.SoundGearEarmold,
            ].includes(orderState.cartItemTypeId!) && (
                <>
                    <div className="row">
                        <div className="col-md-12">
                            <p>
                                <b>
                                    {productDetailState.isCustom
                                        ? intl.formatMessage({
                                              id: 'Faceplate_Color',
                                              defaultMessage: 'Faceplate Color',
                                          })
                                        : intl.formatMessage({
                                              id: 'Case_Color',
                                              defaultMessage: 'Case Color',
                                          })}{' '}
                                </b>
                                {'  '}
                                {intl.formatMessage({
                                    id: translateColor(true, 'Case'),
                                    defaultMessage: translateColor(
                                        false,
                                        'Case'
                                    ),
                                })}
                            </p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <ColorSelector
                                name={
                                    productDetailState.isCustom
                                        ? 'CustomColorPlate'
                                        : 'ColorSelection'
                                }
                                faceplates={faceplates}
                                shells={shells}
                                orderState={orderState}
                                productDetails={productDetailState}
                                onHover={onHover}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                </>
            )}
            {[
                CartItemTypes.CustomOnly,
                CartItemTypes.ApReceiver,
                CartItemTypes.SoundGearCustom,
            ].includes(orderState.cartItemTypeId!) && (
                <>
                    <div className="row">
                        <div className="col-md-12">
                            <p>
                                <b>
                                    {intl.formatMessage({
                                        id: 'Shell_Color',
                                        defaultMessage: 'Shell Color',
                                    })}
                                </b>
                                {'  '}

                                {intl.formatMessage({
                                    id: translateColor(true, 'Shell'),
                                    defaultMessage: translateColor(
                                        false,
                                        'Shell'
                                    ),
                                })}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <ColorSelector
                                name={'CustomColorShell'}
                                faceplates={faceplates}
                                shells={shells}
                                orderState={orderState}
                                productDetails={productDetailState}
                                useShellsForCustom={true}
                                onHover={onHover}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
